import React, { Suspense, memo } from 'react';

// Lazy-load the chart.js-backed implementation; see BarChart/index.js for rationale.
const PieChartInner = React.lazy(() => import('./PieChartInner'));

const PieChart = (props) => (
  <Suspense fallback={null}>
    <PieChartInner {...props} />
  </Suspense>
);

export default memo(PieChart);
